<template>
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        :inline="inline"
        class="form"
        :label-width="labelWidth"
        :label-position="labelPosition"
    >
        <slot></slot>
    </el-form>
</template>

<script>
export default {
    name: 'SyForm',
    props: {
        /**
         * 表单对象
         */
        form: {
            type: Object,
            default: () => {}
            // required: true
        },
        /**
         * 表单验证规则对象
         */
        rules: {
            type: Object,
            default: () => {}
        },
        /**
         * 内联表单
         */
        inline: {
            type: Boolean,
            default: false
        },
        labelPosition: {
            type: String,
            default: 'left'
        },
        labelWidth: {
            type: String,
            default: 'auto'
        }
    },
    computed: {
        /**
         * el-form引用
         */
        elForm() {
            return this.$refs.form;
        }
    }
};
</script>

<style lang="scss" scoped>
.form {
    padding: 0 48px;

    &::v-deep {
        .el-input,
        .el-textarea,
        .el-date-editor {
            width: 200px;
        }
    }
}
</style>
